import React, { createContext, useContext } from "react";
import { useOrganization } from "./organization.context";

type IntegrationContextType = {
  isIntegrationEnabled: (name: string) => boolean;
};

const IntegrationContext = createContext<IntegrationContextType>(
  {} as IntegrationContextType,
);

export const IntegrationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { activeOrg } = useOrganization();

  const isIntegrationEnabled = (name: string) => {
    return activeOrg?.integrations?.find((e) => e.provider === name)?.isActive;
  };

  return (
    <IntegrationContext.Provider
      value={{
        isIntegrationEnabled,
      }}
    >
      {children}
    </IntegrationContext.Provider>
  );
};

export const useIntegrations = () => useContext(IntegrationContext);
